import cntl from "cntl";
import PropTypes from "prop-types";
import { SIZE } from "../constants";
import { useState, useMemo } from "react";

const propTypes = {
  name: PropTypes.string,
  onBlur: PropTypes.func,
  onKeyUp: PropTypes.func,
  onPaste: PropTypes.func,
  onClick: PropTypes.func,
  onFocus: PropTypes.func,
  onChange: PropTypes.func,
  onKeyDown: PropTypes.func,
  isDisabled: PropTypes.bool,
  className: PropTypes.string,
  onInputChange: PropTypes.func,
  size: PropTypes.oneOf([SIZE.sm, SIZE.md, SIZE.lg]),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

function MegaInput({
  id,
  size,
  name,
  value,
  onBlur,
  onKeyUp,
  onPaste,
  onClick,
  onFocus,
  inputRef,
  onChange,
  onKeyDown,
  className,
  isDisabled,
  placeholder,
}) {
  const [fontStyle, setFontStyle] = useState("");
  const [dimensions, setDimensions] = useState("");

  const inputCn = () => cntl`
    mega-input
    border
    p-0
    form-input
    shadow-xs
    rounded-lg
    text-center
    border-primary-300
    enable:bg-white
    disabled:bg-grey-50
    enabled:text-primary-600
    disabled:text-grey-200
    hover:enabled:text-primary-600
    hover:enabled:border-primary-300
    focus:ring-4
    focus:ring-offset-0
    focus:ring-primary-100
    focus:border-primary-300
    focus:enabled:text-primary-600
    placeholder:text-grey-300
    caret-transparent
    active:bg-red
    placeholder-shown:border-grey-300
    selection:bg-transparent
    ${fontStyle}
    ${dimensions}
    ${className ? className : undefined}
  `;

  useMemo(() => {
    switch (size) {
      case SIZE.sm:
        setFontStyle("text-4xl sm:text-5xl");
        setDimensions("w-full sm:w-16 h-16");
        break;
      case SIZE.md:
        setFontStyle("text-4xl sm:text-5xl");
        setDimensions("w-full sm:w-20 h-20");
        break;
      case SIZE.lg:
        setFontStyle("text-5xl sm:text-6xl");
        setDimensions("w-full sm:w-24 h-24");
        break;
      default:
        setFontStyle("text-4xl sm:text-5xl");
        setDimensions("w-full sm:w-16 h-16");
        break;
    }
  }, [size]);

  return (
    <input
      id={id}
      name={name}
      value={value}
      ref={inputRef}
      type="text"
      maxLength={1}
      onPaste={onPaste}
      onKeyUp={onKeyUp}
      onClick={onClick}
      onFocus={onFocus}
      onKeyDown={onKeyDown}
      disabled={isDisabled}
      className={inputCn()}
      placeholder={placeholder}
      onChange={(e) => {
        if (onChange) {
          onChange(e);
        }
      }}
      onBlur={(e) => {
        if (onBlur) {
          onBlur(e);
        }
      }}
    />
  );
}

MegaInput.propTypes = propTypes;
export default MegaInput;
